<script context="module" lang="ts">
	export interface OptionType {
		name: string;
		value: string;
		icon?: string;
		iconSet?: string;
	}
</script>

<script lang="ts">
	import { ButtonGroup, type SelectOptionType } from "flowbite-svelte-v1";
	import { createEventDispatcher } from "svelte";
	import { twMerge } from "tailwind-merge";
	import Icon from "#lib/components/Icon.svelte";
	import Button from "#lib/ui/Button/index.js";

	interface $$Events {
		change: CustomEvent<string>;
	}

	const dispatch = createEventDispatcher();

	export let value: string;
	export let options: OptionType[];
	export let ariaLabel: string | undefined = undefined;

	function select(e: MouseEvent, newValue: SelectOptionType<string>) {
		e.preventDefault();
		if (value !== newValue.value) {
			value = newValue.value;
			dispatch("change", value);
		}
	}
</script>

<div>
	<ButtonGroup size="sm" class="shadow-none" role="group" aria-label={ariaLabel}>
		{#each options as option, i (i)}
			<Button size="md" color="light" class={twMerge("font-medium", value === option.value ? "hover:bg-white" : "bg-gray-100 text-gray-400 hover:text-gray-900", i !== options.length - 1 && "border-r-0")} data-action-name="asset-state-filter" data-action-title={option.name} aria-pressed={value === option.value} on:click={e => select(e, option)}>
				{#if option.icon}
					<Icon iconSet={option.iconSet} name={option.icon} class="h-6 w-6" />
				{:else}
					{option.name}
				{/if}
			</Button>
		{/each}
	</ButtonGroup>
</div>
